import Rollbar from 'rollbar';

export const RollbarLogger = new Rollbar({
	accessToken: window.clientRuntimeConfig.rollbarToken,
	environment: window.clientRuntimeConfig.rollbarEnvironment,
	captureUncaught: true,
	captureUnhandledRejections: true,
	scrubFields: ['signedToken', 'token'],
});
